export default __webpack_public_path__ + "static/media/shop.49a94c03.svg";